import React from 'react';
import { Checkbox, FormControlLabel, Box } from '@applyboard/ui-components';
var ArrivalStatus = function ArrivalStatus(_ref) {
  var disableEnrollmentConfirmed = _ref.disableEnrollmentConfirmed,
    disableReadyToEnroll = _ref.disableReadyToEnroll,
    enrollmentConfirmedOnChange = _ref.enrollmentConfirmedOnChange,
    enrollmentConfirmedToolTip = _ref.enrollmentConfirmedToolTip,
    enrollmentConfirmedValue = _ref.enrollmentConfirmedValue,
    readyToEnrollOnChange = _ref.readyToEnrollOnChange,
    readyToEnrollToolTip = _ref.readyToEnrollToolTip,
    readyToEnrollValue = _ref.readyToEnrollValue;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: readyToEnrollValue,
      onChange: readyToEnrollOnChange,
      name: "ready_to_enroll",
      color: "primary",
      disabled: disableReadyToEnroll
    }),
    "data-tip": readyToEnrollToolTip,
    "data-for": "status-disabled-tooltip",
    label: "Ready to Enroll",
    labelPlacement: "start",
    m: 0
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Checkbox, {
      checked: enrollmentConfirmedValue,
      onChange: enrollmentConfirmedOnChange,
      name: "enrollment_confirmed",
      color: "primary",
      disabled: disableEnrollmentConfirmed
    }),
    "data-tip": enrollmentConfirmedToolTip,
    "data-for": "status-disabled-tooltip",
    label: "Enrollment Confirmed",
    labelPlacement: "start",
    m: 0
  }));
};
export default ArrivalStatus;